import * as mutationType from "../mutation_types";
import moment from "moment";

const state = {
  overview: {},
  categories: [],
  outstanding: [],
  feedback: []
};

const getters = {
  overview: state => state.overview || {},
  pulses: (state, getters) => getters.overview.pulses || [],
  regular_pulses: (state, getters) =>
    getters.pulses.filter(x => !x.isRegistration) || [],
  pulse_scheduled: (state, getters) =>
    getters.regular_pulses.filter(x => x.sentDate == null).length > 0,
  pulse_sent: (state, getters) =>
    getters.regular_pulses.filter(x => x.sentDate != null).length > 0,
  categories: state => state.categories || [],
  outstanding: state => state.outstanding,
  feedback: state => state.feedback
};

const actions = {
  getOverview({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/pulse`)
        .then(res => {
          commit(mutationType.SET_PULSE_OVERVIEW, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getQuestions({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/pulse/categories`)
        .then(res => {
          commit(mutationType.SET_PULSE_CATEGORIES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  toggleCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(
          `/api/pulse/categories/${category.id}/toggle/${category.isEnabled}`
        )
        .then(() => {
          commit(mutationType.TOGGLE_PULSE_CATEGORY, category);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  toggleQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/pulse/questions/${question.id}/toggle`, question)
        .then(res => {
          commit(mutationType.TOGGLE_PULSE_QUESTION, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  start({}, start) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/pulse/start`, start)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  pause({}, start) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/pulse/pause`, start)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getOutstandingPulses({ commit }) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get("/api/pulse/outstanding")
        .then(res => {
          commit(mutationType.SET_OUTSTANDING_PULSES, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  getPulseFeedback({ commit }, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/pulse/feedback`, filter)
        .then(res => {
          commit(mutationType.SET_PULSE_FEEDBACK, res.data);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  acknowledgeFeedback({ commit }, feedback) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .put(`/api/pulse/feedback/acknowledge`, feedback)
        .then(() => {
          commit(mutationType.SET_PULSE_FEEDBACK_ACKNOWLEDGE, feedback);
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  exportFeedback({}, filter) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/pulse/feedback/export", filter)
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `feedback_export_${moment().format("MM_DD_YYYY_HH_mm")}.csv`
          );
          document.body.appendChild(link);
          link.click();
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/pulse/categories", category)
        .then(res => {
          commit(mutationType.SET_PULSE_CATEGORY, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteCategory({ commit }, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/pulse/categories/${id}`)
        .then(res => {
          commit(mutationType.REMOVE_PULSE_CATEGORY, id);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveSubCategory({ commit }, category) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/pulse/subcategories", category)
        .then(res => {
          commit(mutationType.SET_PULSE_SUB_CATEGORY, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post("/api/pulse/questions", question)
        .then(res => {
          commit(mutationType.SET_PULSE_QUESTION, res.data);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  deleteQuestion({ commit }, question) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/pulse/questions/${question.id}`)
        .then(res => {
          commit(mutationType.REMOVE_PULSE_QUESTION, question);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  sendReminder({}, id) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .get(`/api/pulse/${id}/reminder`)
        .then(res => {
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  saveHighLow({ commit }, list) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/pulse/highlow`, list)
        .then(res => {
          commit(mutationType.SET_PULSE_CATEGORIES, res);
          resolve(res.data.id);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {
  [mutationType.SET_PULSE_OVERVIEW](state, item) {
    state.overview = item;
  },
  [mutationType.SET_PULSE_CATEGORIES](state, list) {
    state.categories = list;
  },
  [mutationType.TOGGLE_PULSE_CATEGORY](state, category) {
    let index = state.categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.categories[index].isEnabled = category.isEnabled;
      for (var i = 0; i < state.categories[index].questions.length; i++) {
        state.categories[index].questions[i].isEnabled = category.isEnabled;
      }
    }
  },
  [mutationType.TOGGLE_PULSE_QUESTION](state, category) {
    let index = state.categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.categories[index].isEnabled = category.isEnabled;
      for (var i = 0; i < state.categories[index].questions.length; i++) {
        var question = category.questions.find(
          x => x.id == state.categories[index].questions[i].id
        );
        if (question) {
          state.categories[index].questions[i].isEnabled = question.isEnabled;
        }
      }
    }
  },
  [mutationType.SET_OUTSTANDING_PULSES](state, list) {
    state.outstanding = list;
  },
  [mutationType.SET_PULSE_FEEDBACK](state, list) {
    state.feedback = list;
  },
  [mutationType.SET_PULSE_FEEDBACK_ACKNOWLEDGE](state, list) {
    list.forEach(feedback => {
      let index = state.feedback.findIndex(x => x.id == feedback.id);
      if (index >= 0) {
        state.feedback[index].acknowledgedDate = moment();
        state.feedback[index].responseMessage = feedback.responseMessage;
      }
    });
  },
  [mutationType.SET_PULSE_CATEGORY](state, category) {
    let index = state.categories.findIndex(x => x.id == category.id);
    if (index >= 0) {
      state.categories[index] = Object.assign(
        state.categories[index],
        category
      );
    } else {
      state.categories.push(category);
    }
  },
  [mutationType.REMOVE_PULSE_CATEGORY](state, id) {
    let index = state.categories.findIndex(x => x.id == id);
    if (index >= 0) {
      state.categories.splice(index, 1);
    }
  },
  [mutationType.SET_PULSE_SUB_CATEGORY](state, category) {
    let index = state.categories.findIndex(x => x.id == category.categoryId);
    if (index >= 0) {
      for (let i = 0; i < state.categories[index].questions.length; i++) {
        if (
          state.categories[index].questions[i].subCategory &&
          state.categories[index].questions[i].subCategory.id == category.id
        ) {
          state.categories[index].questions[i] = Object.assign(
            state.categories[index].questions[i],
            category
          );
        }
      }

      let scIndex = state.categories[index].subCategories.findIndex(
        x => x.id == category.id
      );
      if (scIndex >= 0) {
        state.categories[index].subCategories[scIndex] = Object.assign(
          state.categories[index].subCategories[scIndex],
          category
        );
      }
    }
  },
  [mutationType.SET_PULSE_QUESTION](state, question) {
    let index = state.categories.findIndex(x => x.id == question.categoryId);
    if (index >= 0) {
      var qIndex = state.categories[index].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex >= 0) {
        state.categories[index].questions[qIndex] = Object.assign(
          state.categories[index].questions[qIndex],
          question
        );
      } else {
        state.categories[index].questions.push(question);
      }
    }
  },
  [mutationType.REMOVE_PULSE_QUESTION](state, question) {
    let index = state.categories.findIndex(x => x.id == question.categoryId);
    if (index >= 0) {
      var qIndex = state.categories[index].questions.findIndex(
        x => x.id == question.id
      );
      if (qIndex >= 0) {
        state.categories[index].questions.splice(qIndex, 1);
      }
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
